<template>
    <amf-form title="Recent Opportunities" class="full-width" v-if="visible" :menu-items="['Refresh', 'Manual Entry']">
        <table class="table table-sm table-condensed table-hover">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Plans</th>
                    <th>Created On</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="sfdcExport in sfdcExports" :key="sfdcExport.id">
                    <td>{{ sfdcExport.id }}</td>
                    <td>{{ sfdcExport.name }}</td>
                    <td>{{ products(sfdcExport.products) }}</td>
                    <td>{{ $formatters.date(sfdcExport.createdDate, 'MM/DD/YYYY h:mm a') }}</td>
                    <td><a href="#" @click.prevent="finishExport(sfdcExport)">Finish Export</a></td>
                </tr>
            </tbody>
        </table>
    </amf-form>
</template>

<script>
import { modalService } from './utils/modal-service';
import { romeApi } from './utils/rome-api';
export default {
    data() {
        return {
            visible: true,
            sfdcExports: []
        }
    },
    methods: {
        async manualEntry() {
            let salesforceId = await modalService.input('Enter the Opportunity Id from Salesforce');
            await this.finishExport({ id: salesforceId });
        },
        async refresh() {
            this.loadExports();
        },
        async finishExport(sfdcExport) {
            this.busy = true;
            let result = await romeApi.post('salesforce/import/' + sfdcExport.id);
            this.busy = false;

            if(result) {
                await this.loadExports();
                if(result && result.employerId) {
                    let nav = await modalService.confirm('Import Successful. Load Employer now?');
                    if(nav) this.$router.push(`/employer/${result.employerId}/general`);
                }
            }
        },
        async loadExports() {
            this.busy = true;
            let sfdcExports = await romeApi.get('salesforce/export');
            this.sfdcExports = sfdcExports;
            this.busy = false;

        },
        products(value) {
          if(!value) return '';
          return value.join(',');
        }
    },
    async created() {
        this.loadExports();
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/framework/SalesforceExport.vue